export default {
  addDetailsLink: {
    id: 'asp_action_bar_declare_problem_upload_step_add_details_link',
    defaultMessage: 'Add details for the agent',
  },
  submitButton: {
    id: 'asp_action_bar_declare_problem_upload_step_send_button',
    defaultMessage: 'Send to agent',
  },
  textareaLabel: {
    id: 'asp_action_bar_declare_problem_upload_step_textarea_label',
    defaultMessage: 'Add a message',
  },
  optional: {
    id: 'asp_action_bar_declare_problem_upload_step_optional',
    defaultMessage: '(optional)',
  },
  requiredMessageError: {
    id: 'asp_action_bar_declare_problem_upload_step_required_error_message',
    defaultMessage: 'This field is required',
  },
  checkboxLabel: {
    id: 'asp_seller_action_bar_next_task_checkbox',
    defaultMessage: 'Go to the next task after confirming your action.',
  },
  fileInputDescription: {
    id: 'asp_action_bar_declare_problem_upload_step_file_helper_text',
    defaultMessage: '{count} files or less, {maxSize} or less each',
  },
  fileInputErrorMaxFiles: {
    id: 'asp_action_bar_declare_problem_upload_step_file_error_max_files',
    defaultMessage: 'Too many files: maximum {count} files',
  },
  fileInputErrorMaxSize: {
    id: 'asp_action_bar_declare_problem_upload_step_file_error_max_size',
    defaultMessage: 'File is too big: maximum size is {maxSize}',
  },
  fileInputErrorMaxFilesSize: {
    id: 'asp_action_bar_declare_problem_upload_step_file_error_max_files_size',
    defaultMessage: 'Total files size: maximum {maxSize}',
  },
  fileInputErrorMimeType: {
    id: 'asp_action_bar_declare_problem_upload_step_file_error_mimetype',
    defaultMessage:
      'Only .png, .jpg, .jpeg, .pdf, .mp4, .heic, .heif, .zip are allowed',
  },
}
